import { Avatar } from '@engyalo/design-system';
import { InfoArea } from './styled';

type ContactInfoAreaProps = {
  name: string;
  authorRole: string;
};

const AUTHOR_ROLE_BOT = 'bot';
const AUTHOR_ROLE_AGENT = 'agent';

const makeAvatar = (authorRole: string, name: string) => {
  const dataTestID = 'avatar-icon';
  if (authorRole === AUTHOR_ROLE_BOT) {
    return <Avatar variant="icon" customIcon={<i data-testid={dataTestID} className="fa-solid fa-sitemap" />} />;
  }

  if (authorRole === AUTHOR_ROLE_AGENT) {
    return <Avatar variant="icon" customIcon={<i data-testid={dataTestID} className="fa-solid fa-headset" />} />;
  }

  return <Avatar variant="letters" letter={name} />;
};

const ContactInfoArea: React.FC<ContactInfoAreaProps> = ({ name, authorRole }) => (
  <InfoArea>{makeAvatar(authorRole, name)}</InfoArea>
);

export default ContactInfoArea;
